import {
  Autocomplete,
  ControllerRenderProps,
  Input,
  MultiSelectSelectedTags,
} from '@otp/ui';

type EidsProps = {
  field: ControllerRenderProps<any, any>;
  className?: string;
};

export const EidsField = ({
  field: { onChange: onChangeProp, ...field },
  className,
}: EidsProps) => {
  const defaultEidsValue = field.value;

  const onChange = (_: any, newValue: string[]) => onChangeProp(newValue);

  return (
    <Autocomplete
      key={field.value}
      multiple={true}
      freeSolo={true}
      className={className}
      options={[]}
      defaultValue={defaultEidsValue}
      renderTags={(value, getTagProps) => (
        <MultiSelectSelectedTags value={value} getTagProps={getTagProps} />
      )}
      renderInput={(params) => <Input {...params} fullWidth />}
      onChange={onChange}
      {...field}
      onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
        if (e.target.value) {
          onChange(null, [...(field.value || []), e.target.value]);
        }
      }}
      value={undefined}
      ref={undefined}
    />
  );
};
